<template>
  <div class="relative flex w-full">
    <CategorySelect
      :route="route('category-single-list')"
      v-model="value"
      @updateQuery="searchJobsByQuery"
      @typedQuery="typedCategory = $event"
      :multiple="false"
    />
  </div>

  <RegionSelect :route="route('region-list')" v-model="regValue" :regValue="regValue" />

  <div class="relative flex w-full max-h-12">
    <h6
      class="absolute max-w-full px-1 text-xs font-semibold text-theme-secondary left-4 -top-2 truncate backdrop-blur-sm"
    >
      {{ $t('Sort By') }}
    </h6>
    <select
      v-model="sortBy"
      @change="handleSortChange"
      class="block w-full py-2.5 h-10 pl-4 overflow-hidden text-xs border rounded-lg outline-none focus:ring-0 ring-0 text-theme-primary border-theme-divider"
    >
      <option value="newest">{{ $t('Newest') }}</option>
      <option value="vector">{{ $t('Most relevant (AI search)') }}</option>
      <option value="highest_pay">{{ $t('Highest Pay') }}</option>
    </select>
    <!-- <div class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
      <svg class="w-4 h-4 text-theme-secondary dark:text-theme-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div> -->
  </div>

  <div class="flex items-center gap-2">
    <GenericButton
      @click.prevent="searchJobs"
      size="medium"
      theme="secondary"
      type="button"
      :text="$t('Search')"
              outerClass="flex-auto max-h-9"/>
    <div
      class="flex items-center justify-center w-6 h-6 scale-125 cursor-pointer text-theme-secondary shrink-0 xl:hidden"
      @click="$emit('open')"
      :class="{ 'w-30': isActive }"
    >
      <Icon type="filter" />
    </div>
  </div>
</template>

<script>
// import the styles
import 'vue3-treeselect/dist/vue3-treeselect.css';
import CategorySelect from '@/Pages/Jobs/Partials/CategorySelect.vue';
import RegionSelect from './RegionSelect.vue';
import GenericButton from '@/Components/GenericButton.vue';
import Icon from '@/Icons/OptimizedIcons.vue';
export default {
  components: { CategorySelect, RegionSelect, GenericButton, Icon },

  data() {
    return {
      value: null,
      typedCategory: '',
      regValue: '',
      sortBy: 'vector',
      options: [],
      openCategories: false,
      windowWidth: window.innerWidth,
      routes: {
        category: (category) => route('jobs.category', { category }),
        city: (city) => route('jobs.city', { city }),
        categoryAndCity: (category, city) => route('jobs.category.city', { category, city }),
      },
    };
  },
  props: {
    isActive: false,
    class: {
      type: String,
      default: null,
    },
    isMultiple: {
      type: Boolean,
      default: true,
    },
    filters: {
      type: Object,
      default: {},
    },
  },
  inject: ['showToastGlobal'],
  emits: ['loadingStart'],
  methods: {
    getCategorySlug() {
      const rawSlug = this.value?.slug || this.value || this.typedCategory;

      if (!rawSlug) {
        return '';
      }

      const slug = String(rawSlug)
        .trim()
        .replace(/\//g, '-') // Replace / with -
        .replace(/\\/g, '-') // Replace \ with -
        .replace(/%/g, '') // Remove % signs to prevent encoding issues
        .replace(/\s+/g, ' '); // Normalize spaces

      return slug ? encodeURIComponent(slug) : '';
    },
    getCitySlug() {
      if (!this.regValue) {
        return '';
      }

      const city = String(this.regValue).trim();

      return city ? encodeURIComponent(city) : '';
    },
    buildBasePath() {
      const categorySlug = this.getCategorySlug();
      const city = this.getCitySlug();

      if (categorySlug && city) {
        return this.routes.categoryAndCity(categorySlug, city);
      }

      if (categorySlug) {
        return this.routes.category(categorySlug);
      }

      if (city) {
        return this.routes.city(city);
      }

      const isFilteredPage = Boolean(this.filters?.category || this.filters?.city);

      return isFilteredPage ? route('jobs') : window.location.pathname;
    },
    buildQueryString() {
      const params = new URLSearchParams(window.location.search);

      params.delete('page');

      if (this.sortBy && this.sortBy !== 'vector') {
        params.set('sort', this.sortBy);
      } else {
        params.delete('sort');
      }

      const query = params.toString();

      return query ? `?${query}` : '';
    },
    buildSearchUrl() {
      return this.buildBasePath() + this.buildQueryString();
    },
    searchJobs() {
      this.$emit('loadingStart');
      this.openCategories = false;

      return this.$inertia.get(
        this.buildSearchUrl(),
        {},
        {
          preserveScroll: true,
        }
      );
    },
    searchJobsByQuery(query) {
      this.value = query;
      this.typedCategory = query;

      return this.searchJobs();
    },
    getSelectedCategories() {
      if (this.filters?.category) {
        return this.filters.category;
      }
      return '';
    },
    getSelectedRegion() {
      if (this.filters?.city) {
        return this.filters.city;
      }
      return '';
    },
    clearSelection() {
      this.value = null;
      this.typedCategory = '';

      return this.searchJobs();
    },
    deselectCategory(event) {
      if (this.openCategories === false) {
        this.value = this.value.filter((item) => item !== event.id);

        return this.searchJobs();
      }
    },
    handleSortChange() {
      return this.searchJobs();
    },
    getSortFromUrl() {
      const params = new URLSearchParams(window.location.search);
      return params.get('sort') || 'vector';
    },
  },
  beforeMount() {
    this.value = this.getSelectedCategories();
    this.regValue = this.getSelectedRegion();
    this.sortBy = this.getSortFromUrl();
  },
};
</script>
